import { Component } from '@angular/core';
@Component({
  selector: 'bav-reporting-ui-common-error',
  templateUrl: './error.component.html',
})
export class ErrorComponent {
  constructor() {}
}
